// extracted by mini-css-extract-plugin
export default {"error":"error-not-found_error__j8H-c","code":"error-not-found_code__6ImUq"};